"use client";
import "react";
import r from "./index.es65.js";
r.div`
  :root {
    @keyframes spinner {
      0% {
        transform: rotate(0);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }

  width: 48px;
  height: 48px;
  animation: spinner 0.6s linear infinite;

  .full {
    stroke: #e1ebe4;
  }
  .part {
    stroke: #2f6341;
    stroke-dasharray: 32 126;
    stroke-dashoffset: 64;
  }
`;
//# sourceMappingURL=index.es28.js.map
